import { render, staticRenderFns } from "./RelatorioCargaDescargaListConcluidos.vue?vue&type=template&id=2b591077"
import script from "./RelatorioCargaDescargaListConcluidos.vue?vue&type=script&lang=js"
export * from "./RelatorioCargaDescargaListConcluidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports